/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedStandardProductRequestDto } from '../../models/backend-patched-standard-product-request-dto';
import { BackendStandardProductDto } from '../../models/backend-standard-product-dto';

export interface SalesStandardProductsPartialUpdate$Params {
  id: number;
  body?: BackendPatchedStandardProductRequestDto;
}

export function salesStandardProductsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: SalesStandardProductsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendStandardProductDto>> {
  const rb = new RequestBuilder(rootUrl, salesStandardProductsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendStandardProductDto>;
    }),
  );
}

salesStandardProductsPartialUpdate.PATH = '/api/sales/standard-products/{id}/';
